import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { backgroundsReducer } from "./backgrounds.reducer";
import { BackgroundsEffects } from "./backgrounds.effects";

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature("backgrounds", backgroundsReducer),
    EffectsModule.forFeature([BackgroundsEffects]),
  ],
})
export class BackgroundsModule {}
